import { CartOrdersList } from '@/components/CartOrdersList';
import { Heading } from '@/components/Heading';
import { Promotions } from '@/components/Promotions';
import { usePageData } from '@/contexts/pageContext';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { OrderItem } from '@/types';
import * as Styled from './BasketSummary.styled';

interface BasketSummaryProps {
  items: OrderItem[] | null;
}

export const BasketSummary = ({ items }: BasketSummaryProps) => {
  const isSmallScreen = useMediaQuery('(width < 48rem)');
  const { subheading } = usePageData();

  const numberOfCartItems = items?.reduce(
    (sum, item) => sum + item.quantity,
    0,
  );
  const itemsText = `${numberOfCartItems} item${numberOfCartItems === 1 ? '' : 's'}`;

  return (
    <Styled.Section>
      <Styled.HGroup>
        <Heading styledAs={1} level={2}>
          You have {itemsText} in your cart
        </Heading>
        {subheading ? <p>{subheading}</p> : null}
      </Styled.HGroup>
      {isSmallScreen ? <Promotions /> : null}
      {items ? (
        <CartOrdersList isBasketPage={true} orders={items} />
      ) : null}
    </Styled.Section>
  );
};
